import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Skeleton } from "@mantine/core";
import { loadingStates } from "../../utilities/utilities";
import {
  customChartData,
  customChartDataForLocation,
} from "../../utilities/utilities";
import DoughnutChart from "../doughnutChart/doughnutChart";

ChartJS.register(ArcElement, Tooltip, Legend);

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "right",
      labels: {
        boxHeight: 10,
        boxWidth: 10,
      },
    },
  },
};

const ChartCard = ({ title, children }) => (
  <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
    <h3 className="mb-3 text-sm font-semibold capitalize text-gray-700">
      {title}
    </h3>
    <div className="relative h-52 w-full">{children}</div>
  </div>
);

const AgreementAnalytics1 = ({ filters, setFilter, configs }) => {
  const isLoading = configs.loading === loadingStates.LOADING;

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {isLoading ? (
          <>
            <Skeleton height={280} radius="md" />
            <Skeleton height={280} radius="md" />
          </>
        ) : (
          <>
            <ChartCard title="category">
              <DoughnutChart
                chartOptions={chartOptions}
                method={customChartData("typeOfAgreement")}
                data={configs?.data?.agreementTypeWise}
                filters={filters}
                type="typeOfAgreement"
                setFilters={setFilter}
              />
            </ChartCard>

            <ChartCard title="business unit">
              <DoughnutChart
                chartOptions={chartOptions}
                method={customChartDataForLocation("location")}
                data={configs?.data?.agreementsLocationWise}
                filters={filters}
                setFilters={setFilter}
                type="mapBusinessunit"
              />
            </ChartCard>
          </>
        )}
      </div>
    </div>
  );
};

export default AgreementAnalytics1;
